import { Icon } from '@chakra-ui/react'
import { BiDotsHorizontalRounded } from 'react-icons/bi'

export const Dots = props => <Icon as={BiDotsHorizontalRounded} {...props} />
